import { createMutation } from "@evergis/react-fetching";
import { DeleteByConditionParams, LayerUpdateInfoDc } from "@evergis/api";

import { api as evergisApi } from "../evergis/api";
import { invalidateTable } from "./invalidations";
import { features } from "./features";

export const deleteFeature = createMutation(
  ({ name, id, tableName }: { name: string; id: string; tableName: string }) =>
    async api => {
      let result: LayerUpdateInfoDc;

      try {
        result = await api.layers.deleteFeatures({ name, ids: [id] });
      } catch {
        console.warn(`Unable to delete feature:${id} for layer: ${name}`);
      }

      return {
        data: { result, tableName, name },
      };
    },
  {
    injected: evergisApi,
    update: ({ tableName, name }) => {
      features.invalidateAll();
      invalidateTable(tableName, [name]);
    },
  },
);

export const deleteFeaturesByCondition = createMutation(
  (params: DeleteByConditionParams & { tableName?: string }) => async api => ({
    data: { result: await api.layers.deleteByCondition(params), layerName: params.name, tableName: params.tableName },
  }),
  {
    injected: evergisApi,
    update: ({ layerName, tableName }) => {
      features.invalidateAll();
      invalidateTable(tableName, [layerName]);
    },
  },
);
